import config from 'config/config.demo';

export default {
  ...config,
  gtmKey: 'GTM-M8PXJJG7',
};
